import { render } from "./TopWorstFirstForm.vue?vue&type=template&id=4252336c&scoped=true"
import script from "./TopWorstFirstForm.vue?vue&type=script&lang=js"
export * from "./TopWorstFirstForm.vue?vue&type=script&lang=js"

import "./TopWorstFirstForm.vue?vue&type=style&index=0&id=4252336c&lang=scss&scoped=true"
import "./TopWorstFirstForm.vue?vue&type=style&index=1&id=4252336c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4252336c"]])

export default __exports__